import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 言語jsonファイルのimport
//日本語
import translation_ja from "./ja.json";
//英語
import translation_en from "./en.json";
//中国語（繁体語）
import translation_zh_tw from "./zh-tw.json";
//中国語（簡体語）
import translation_zh_cn from "./zh-cn.json";
//韓国語
import translation_ko from "./ko.json";
//ベトナム語
import translation_vi from "./vi.json";
//タイ語
import translation_th from "./th.json";
//インドネシア語
import translation_id from "./id.json";
import { LANGUAGES } from "../../utils/Constants";

const resources = {
	ja: {
		translation: translation_ja,
	},
	en: {
		translation: translation_en,
	},
	"zh-TW": {
		translation: translation_zh_tw,
	},
	zh: {
		translation: translation_zh_cn,
	},
	ko: {
		translation: translation_ko,
	},
	vi: {
		translation: translation_vi,
	},
	th: {
		translation: translation_th,
	},
	id: {
		translation: translation_id,
	},
};

/**
 * アプリ内の言語設定として使える言語コードへ変更する。
 * @param {String} language
 * @returns
 */
const convertLanguageCode = (language: string) => {
	if (language.includes("ja")) return "ja";
	if (language.includes("zh-TW") || language.includes("zh_tw")) return "zh-TW";
	if (
		language.includes("zh-CN") ||
		language.includes("zh_cn") ||
		language.includes("zh")
	) {
		return "zh";
	}

	if (language.includes("ko")) return "ko";
	if (language.includes("vi")) return "vi";
	if (language.includes("th")) return "th";
	if (language.includes("id")) return "id";
	return "en";
};

/**
 * サポート言語を取得する。
 * @returns
 */
export const getSupportedLanguages = () => {
	try {
		const { supportedLanguages } = JSON.parse(
			localStorage.getItem("APP_CONFIG") ?? "{}"
		);
		if (!supportedLanguages) {
			throw new Error("supported languages is not found");
		}
		return supportedLanguages.map(convertLanguageCode);
	} catch (error) {
		console.log(error);
		// 最低限、日本語と英語は保証する。
		return ["ja", "en"];
	}
};

/**
 * 選択可能な言語一覧
 * サポートさている言語のうちで選ぶ。
 */
export const getSelectableLanguages = () => {
	const supportedLanguages = getSupportedLanguages();
	return LANGUAGES.filter(({ key }) => {
		return supportedLanguages.includes(key);
	});
};

/**
 * ブラウザの言語設定・url内の言語設定を取得する
 * @param {boolean} [referLocal=false] localStorageに保持した言語設定を参照するかどうか
 * @returns {string}
 */
export const detectBrowserLanguage = (referLocal = false) => {
	const language =
		// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
		(referLocal && localStorage.getItem("lang")) ||
		(window.navigator.languages != null && window.navigator.languages[0]) ||
		window.navigator.language;
	return convertLanguageCode(language);
};

const detectedLanguage = detectBrowserLanguage();
const supportedLanguages = getSupportedLanguages();
const applyLanguage = supportedLanguages.includes(detectedLanguage)
	? detectedLanguage
	: "en";
// !アプリ設定が未取得の場合もあるため、ここでは言語設定を保持しない。

void i18n.use(initReactI18next).init({
	resources,
	lng: applyLanguage,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
